// Fusion des stats de plusieurs pages d'un même réseau (format de /reporting/page-stats), pour les panneaux du Reporting
// Valeurs sommées, séries par jour sommées date par date, taux et moyennes moyennés, listes (publications…) concaténées
const RATIO = /rate|ratio|avg|average|percent|moyenne|duration/i

const isSeriesItem = x => x && typeof x === 'object' && !Array.isArray(x) && x.date != null &&
  Object.keys(x).every(k => k === 'date' || typeof x[k] === 'number' || x[k] == null)

function mergeSeries(arrays) {
  const byDate = new Map()
  arrays.forEach(arr => arr.forEach(item => {
    const row = byDate.get(item.date) || { date: item.date }
    Object.keys(item).forEach(k => {
      if (k !== 'date' && typeof item[k] === 'number') row[k] = (row[k] || 0) + item[k]
    })
    byDate.set(item.date, row)
  }))
  return [...byDate.values()].sort((a, b) => a.date - b.date)
}

function mergeValues(values, key) {
  const defined = values.filter(v => v !== null && v !== undefined)
  if (!defined.length) return values.length ? values[0] : undefined
  if (defined.every(v => typeof v === 'number')) {
    const sum = defined.reduce((s, v) => s + v, 0)
    return RATIO.test(key || '') ? sum / defined.length : sum
  }
  if (defined.every(Array.isArray)) {
    const flat = [].concat(...defined)
    return flat.length && flat.every(isSeriesItem) ? mergeSeries(defined) : flat
  }
  if (defined.every(v => typeof v === 'object')) {
    const keys = new Set()
    defined.forEach(v => Object.keys(v).forEach(k => keys.add(k)))
    const out = {}
    keys.forEach(k => { out[k] = mergeValues(defined.map(v => v[k]), k) })
    return out
  }
  return defined[0]
}

export function mergeStats(list) {
  const stats = list.filter(Boolean)
  if (stats.length <= 1) return stats[0] || null
  return mergeValues(stats, '')
}
